import React, { useState, useEffect } from 'react';

export default function SilverPrice() {
    const [price, setPrice] = useState("Loading...");

    useEffect(() => {
        const fetchSilverPrice = async () => {
            try {
                const response = await fetch('/silverPrice'); // Calls your REST endpoint
                const text = await response.text(); // Extracts the plain text response
                setPrice(text); // ✅ Sets the silver price
            } catch (error) {
                console.error("Error fetching silver price:", error);
                setPrice("Unavailable"); // Fallback in case of error
            }
        };

        fetchSilverPrice();

        // Optional: Refresh the price every 5 minutes
        const interval = setInterval(fetchSilverPrice, 5 * 60 * 1000);
        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    return (
        <div className="silver-price">
            <span>Silver Spot Price: ${price} / oz</span>
        </div>
    );
}

